import EventBanner from "../../../../components/sections/front/EventBanner";
import AboutEvent from "../../../../components/sections/front/AboutEvent";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import { lngDetect } from "../../../../helpers/lngDetect";

const EventDetails = () => {
  const navigate = useNavigate();
  const { lang } = useSelector((state) => state?.langProvider);
  const {
    event: eventDetailsData,
    eventLoading,
    eventOrganizer,
    ...rest
  } = useOutletContext();

  if (!eventDetailsData?.data?._id && !eventLoading) {
    navigate(`/${lang}/events`);
    return;
  }

  return (
    <>
      <EventBanner
        event={eventDetailsData?.data || {}}
        title={lngDetect(eventDetailsData?.data?.title)}
      />
      <AboutEvent
        event={eventDetailsData?.data || {}}
        eventOrganizer={eventOrganizer}
      />
    </>
  );
};

export default EventDetails;
